<header>
  <div class="header-left">
    <img class="header-logo" src="../../../assets/images/ps-logo.png" />
    <div class="split-line"></div>
    <img class="header-logo" src="../../../assets/images/lulu-logo.png" />
  </div>
 
</header>
